// MUST BE FIRST: Polyfills for Node.js globals in browser
import "./polyfills";

import { createRoot } from "react-dom/client";
import "./globals.css";
import { initDatadog } from './lib/datadog';
import { registerServiceWorker } from "@commander4/elements/lib/service-worker";

// Initialize Datadog RUM monitoring
initDatadog();

/*
 * The worker is registered BEFORE `App` is imported, and the ordering is load-bearing.
 *
 * Auth contexts in these apps build their OpenAuth client at module scope from
 * `import.meta.env.VITE_AUTH_URL`, so a missing or malformed value throws while that module is still
 * evaluating — taking the whole entry down. A registration statement placed after the import never
 * runs, because static imports are hoisted above every statement regardless of where it sits.
 *
 * Reproduced in deploy-web: with `VITE_AUTH_URL` unset the page threw `Error: No issuer` and
 * `getRegistrations()` returned 0. The cost is specific — a misconfigured deploy loses the cached
 * shell that would otherwise have kept the previous good build usable.
 *
 * A dynamic import for `App` is what makes the ordering real rather than cosmetic.
 */
registerServiceWorker();

const App = (await import("./App.tsx")).default;

createRoot(document.getElementById("root")!).render(<App />);
